import i18n from '@/i18n'
import { buildSocialMeta, PRODUCTION_DOMAIN } from '@/helpers/socialMetaHelper'
import {
  buildLocalizedPath,
  DEFAULT_LOCALE_CODE,
  getHreflangForLocale,
  LOCALE_TO_HREFLANG,
  normalizeLocaleCode,
} from '@/helpers/localeUrlHelper'

const LOCALE_TO_OG_LOCALE = {
  eng: 'en_KE',
  kin: 'rw_RW',
  swa: 'sw_KE',
  nya: 'ny_MW',
}

const DEFAULT_OG_LOCALE = LOCALE_TO_OG_LOCALE[DEFAULT_LOCALE_CODE]

const HREFLANG_ENTRIES = Object.entries(LOCALE_TO_HREFLANG)

export default {
  computed: {
    seoEffectiveLocale() {
      return normalizeLocaleCode(this.$route?.query?.lang) || this.$store?.getters?.languageCode
    },
    seoHtmlLang() {
      return getHreflangForLocale(this.seoEffectiveLocale) || 'en'
    },
  },
  metaInfo() {
    const path = this.$route?.path || '/'
    const canonicalUrl = `${PRODUCTION_DOMAIN}${buildLocalizedPath(path, this.seoEffectiveLocale)}`

    const link = [
      { rel: 'canonical', href: canonicalUrl },
      ...HREFLANG_ENTRIES.map(([localeCode, hreflang]) => ({
        rel: 'alternate',
        hreflang,
        href: `${PRODUCTION_DOMAIN}${buildLocalizedPath(path, localeCode)}`,
      })),
      { rel: 'alternate', hreflang: 'x-default', href: `${PRODUCTION_DOMAIN}${path}` },
    ]

    const langCode = this.seoEffectiveLocale || DEFAULT_LOCALE_CODE
    const ogLocale = LOCALE_TO_OG_LOCALE[langCode] || DEFAULT_OG_LOCALE
    const ogLocaleAlternates = Object.values(LOCALE_TO_OG_LOCALE).filter(l => l !== ogLocale)
    const socialTitle = this.pageTitle || i18n.t('seo.defaultTitle')
    const socialDescription = this.pageDescription || i18n.t('seo.defaultDescription')

    const meta = [
      ...buildSocialMeta(socialTitle, socialDescription, canonicalUrl),
      { vmid: 'og:locale', property: 'og:locale', content: ogLocale },
      ...ogLocaleAlternates.map(l => ({ property: 'og:locale:alternate', content: l })),
    ]

    return {
      htmlAttrs: { lang: this.seoHtmlLang },
      link,
      meta,
    }
  },
}
